import { CancelOutlined, Search } from "@mui/icons-material";
import {
    Alert,
    CircularProgress,
    IconButton,
    InputBase
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AddAccountForm from "../components/forms/addAccountForm";
import AddCustomerForm from "../components/forms/addCustomerForm";
import { getCustomersList } from "../firebase/dataHandler";
import { useTranslation } from "react-i18next";

function Clients() {
  const { t } = useTranslation();
  const [customerList, setCustomerList] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [searchQuerry, setSearchQuerry] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    handleCustomerList();
  }, []);

  const handleCustomerList = () => {
    getCustomersList()
      .then((data) => {
        setLoading(true);
        setCustomerList(data);
        setLoading(false);
      })
      .catch((err) => {
        alert(err);
      });
  };


  return (
    <div className="page-pad fade-in">
      {/* Header */}
      <div style={{ padding: '12px 4px 8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h1 style={{ fontSize: 26, marginBottom: 4 }}>{t('customers.title')}</h1>
          {customerList && (
            <small style={{ color: 'var(--text-muted)', fontSize: 11 }}>
              {Object.values(customerList).filter(a => a.isActive || a.isActive === undefined).length} {t('accounts.active')}
            </small>
          )}
        </div>
        <AddCustomerForm refresh={handleCustomerList} />
      </div>

      <div style={{ height: 1, background: 'var(--border-subtle)', margin: '0 0 14px' }} />

      {/* Search */}
      <div style={{
        display: 'flex', alignItems: 'center',
        background: 'var(--bg-card)', border: '1px solid var(--border-subtle)',
        borderRadius: 999, padding: '6px 8px 6px 16px', marginBottom: 14,
      }}>
        <InputBase
          sx={{ flex: 1, fontFamily: 'Inter, sans-serif', fontSize: 13, color: 'var(--text-primary)' }}
          placeholder={t('customers.search_placeholder')}
          value={searchQuerry}
          onChange={(e) => setSearchQuerry(e.target.value)}
        />
        <IconButton size="small" sx={{ color: !searchQuerry ? 'var(--text-muted)' : 'var(--accent-red)' }} onClick={() => setSearchQuerry('')}>
          {!searchQuerry ? <Search style={{ fontSize: 18 }} /> : <CancelOutlined style={{ fontSize: 18 }} />}
        </IconButton>
      </div>

      {isLoading && <div style={{ display: 'flex', justifyContent: 'center', padding: 32 }}><CircularProgress size={28} /></div>}

      {customerList ? (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '16px' }}>
          {Object.values(customerList)
          .sort((a, b) => a.name.localeCompare(b.name))
          .filter((a) => a.isActive || a.isActive === undefined)
          .map((data) => {
            const query = searchQuerry ? searchQuerry.toLowerCase() : '';
            const show = !query || (data?.name || '').toLowerCase().includes(query);
            return show && (
                <div
                  key={data.clientId}
                    style={{
                      display: 'flex', alignItems: 'center',
                      background: 'var(--bg-card)',
                      border: '1px solid var(--border-subtle)',
                      borderRadius: 16, padding: '12px 14px',
                      transition: 'all 0.2s ease', cursor: 'pointer',
                    }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(21, 195, 88, 0.3)'; e.currentTarget.style.background = 'var(--bg-card-hover)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border-subtle)'; e.currentTarget.style.background = 'var(--bg-card)'; }}
                >
                  {/* Avatar */}
                  <div
                    onClick={() => navigate(`/customers/${data.clientId.split('_')[0]}`)}
                    style={{
                      width: 42, height: 42, borderRadius: 14, flexShrink: 0,
                      background: 'linear-gradient(135deg, #15C358, #109441)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontFamily: 'Inter, sans-serif', fontWeight: 700, fontSize: 16, color: '#fff',
                      marginRight: 14,
                    }}
                  >
                    {data.name[0].toUpperCase()}
                  </div>

                  {/* Name + town */}
                  <div
                    style={{ flex: 1 }}
                    onClick={() => navigate(`/customers/${data.clientId.split('_')[0]}`)}
                  >
                    <p style={{ textAlign: 'left', fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: 14, color: 'var(--text-primary)', marginBottom: 2 }}>{data.name}</p>
                    <p style={{ textAlign: 'left', fontFamily: 'Inter, sans-serif', fontSize: 11, color: 'var(--text-secondary)' }}>{data.townName || t('customers.no_town')}</p>
                  </div>

                  {/* Add Account */}
                  <AddAccountForm
                    customer={{ name: data.name, contact: data.contact, clientId: data.clientId }}
                  />
                </div>
              );
            })}
        </div>
      ) : (
        <div style={{ padding: '32px 16px' }}>
          <Alert severity="info">{t('customers.no_data')}</Alert>
        </div>
      )}
    </div>
  );
}

export default Clients;
